export const FEEDBACK = 'Feedback';
export const USER_PROFILE = 'UserProfile';
export const TRADEUNION_NEWS = 'TradeUnionNews';
export const DOWNLOADABLE = 'Downloadable';
